import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'
import { AppConfig } from './app.config'
import { AppCountrySettings } from './app-country-settings.config'
import { AppOrganizationSettings } from './app-organization-settings.config'
import { AppSettings } from './app-settings.config'

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class AppLocalLabelsConfig {
    //Provide all the Country Configs here
    public UILABELCONSTANTSv1 



    constructor(
    ) {
    }
}
